import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthResource } from '../resources/auth.resource';
import { AuthRepo } from '../repos/auth.repo';

import { OperationRepo } from '../repos/operation.repo';
import { AuthStateService } from '../../shared/store-state/auth-state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private authResource = inject(AuthResource);
  private authStateService = inject(AuthStateService);
  private authRepo = inject(AuthRepo);
  private operationRepo = inject(OperationRepo);

  login(user, password) {
    return new Observable(observer => {
      this.authResource.login(user, password).subscribe(
        data => {
          this.authResource.me(data.token).subscribe(
            (user: unknown) => {
              user['token'] = data.token;
              observer.next({
                token: data.token,
                user: user,
              });
              observer.complete();
            },
            error => {
              observer.error(error);
            }
          );
        },
        error => {
          observer.error(error);
        }
      );
    });
  }

  loadUser() {
    return this.authRepo.loadUser();
  }

  getUser() {
    return this.authRepo.getUser();
  }

  loadOperation() {
    return this.operationRepo.loadOperation();
  }

  getOperation() {
    return this.operationRepo.getOperation();
  }

  me(token) {
    return this.authResource.me(token);
  }

  operationMe(user, operation) {
    return this.authResource.operationMe(user, operation);
  }

  editProfile(data) {
    const user = this.authRepo.getUser();
    return this.authResource.editProfile(user, data);
  }

  changePassword(data) {
    const user = this.authRepo.getUser();
    return this.authResource.changePassword(user, data);
  }

  rememberPassword(data: { email: string }) {
    return this.authResource.rememberPassword(data);
  }

  getOpertations() {
    const user = this.authRepo.getUser();

    this.authResource.unpaginate(true);
    return this.authResource.getOperations(user);
  }

  saveUser(user) {
    return this.authRepo.setUser(user);
  }

  saveOperation(op) {
    return this.operationRepo.setOperation(op);
  }

  deleteUser() {
    this.authStateService.set('user', null);
    this.authStateService.set('operation', null);
    this.authRepo.removeUser();
    this.operationRepo.removeOperation();
  }
}
